import { Typography, styled } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch } from "../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import ListsTable from "./components/lists-table";
import { ISelectedFilters } from "./interface/selected-filters";
import {
    dataBrowserListSetFiltersAction,
    initDataBrowserListAction,
} from "./redux/lists.actions";

const extractStringFilter = (
    queryParams: URLSearchParams,
    queryKey: string,
): string | undefined => {
    const value = queryParams.get(queryKey);
    return value ?? undefined;
};

const extractStringArrayFilter = (
    queryParams: URLSearchParams,
    queryKey: string,
): Array<string> | undefined => {
    const value = queryParams.get(queryKey);
    return value !== null ? [value] : undefined;
};

const extractFiltersFromQuery = (
    queryParams: URLSearchParams,
): Partial<ISelectedFilters> => {
    const category = extractStringArrayFilter(queryParams, "category");
    const sicCode = extractStringFilter(queryParams, "sic");
    const naicsCode = extractStringFilter(queryParams, "naics");
    const country = extractStringArrayFilter(queryParams, "country");

    return {
        ...(category && { category }),
        ...(sicCode && { sicCode }),
        ...(naicsCode && { naicsCode }),
        ...(country && { country }),
    };
};

const Page = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        dispatch(initDataBrowserListAction());

        const queryParams = new URLSearchParams(location.search);
        const filters = extractFiltersFromQuery(queryParams);

        if (Object.keys(filters).length > 0) {
            dispatch(dataBrowserListSetFiltersAction(filters));
        }

        void navigate("/data-browser", { replace: true });
    }, []);

    return (
        <PageTemplate pageTitle={"RetailStat POI Data"}>
            <Typography variant="h6" className={className}>
                DATA BROWSER
            </Typography>
            <ListsTable />
        </PageTemplate>
    );
};

export default styled(Page)(({ theme }: IWithThemeProps) => ({
    color: theme?.palette.text.primary,
    fontSize: "20px",
    marginBottom: theme?.spacing(10),
    fontWeight: 600,
    textTransform: "uppercase",
}));
